/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "M Abdullah Ch",
  title: "Hi, I'm Abdullah",
  subTitle: emoji(
    "A Software Developer 🚀 who loves making Web Apps with JavaScript / Reactjs / Nodejs and some other cool libraries and frameworks | Microsoft Learn Student Ambassador | Google DSC Lead |"
  ),
  resumeLink:
    "https://drive.google.com/file/d/1YAVpetmH-5nuB8TPkx1adLtY0_BnTD-X/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/abdullah-ch",
  linkedin: "https://www.linkedin.com/in/abdullah-ch/",
  gmail: "abdullahchaudharry@gmail.com",
  stackoverflow: "https://stackoverflow.com/users/13708712/abdullah-ch",
  twitter: "https://twitter.com/MAbdullahCh10",
  // Instagram and Twitter are also supported in the links!
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "MAKE WEBAPPS WITH AWESOME JAVASCRIPT TECHNOLOGIES",
  skills: [
    emoji("⚡ Develop highly interactive Front end Web Apps"),
    emoji("⚡ Develop Maintainable Backend Services")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "vuejs",
      fontAwesomeClassname: "fab fa-vuejs"
    },
    {
      skillName: "GitHub",
      fontAwesomeClassname: "fab fa-github"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: false, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Information Technology University",
      logo: require("./assets/images/itu.jpg"),
      subHeader: "Bachelors of Science in Computer Science",
      duration: "September 2017 - April 2019",
      desc: "Participated in the research of XXX and published 3 papers.",
      descBullets: [
        "I am responsible for making REST APIs for their Education Platform with Node JS",
        "",
        ""
      ]
    },
    {
      schoolName: "Stanford University",
      logo: require("./assets/images/punjabcollege.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "September 2013 - April 2017",
      desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
      descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "70%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "80%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "React JS Developer",
      company: "BigOSoft",
      companylogo: require("./assets/images/logo.png"),
      date: "April 2021 - August 2021",
      desc: "Big O Soft is an innovative IT solutions provider agency developing online solutions for organizations across business sectors, based in Lahore, Pakistan. ",
      descBullets: [
        "Responsible for conceptualizing and executing clear, quality code to develop the best software",
        "Contributed in POS systems and Websites using React JS - Material UI - TypeScript"
      ]
    },
    {
      role: "MERN Stack Intern",
      company: "Kotari",
      companylogo: require("./assets/images/K.jpg"),
      date: "Feb 2021 - April 2021",
      desc: "Kotari is a Social Ecommerce Startup",
      descBullets: [
        "Responsible for creating the Frontend of their Ecommerce Platform using Material-UI",

        "Creating Reusable Components with React JS"
      ]
    },
    {
      role: "Back-end Intern",
      company: "Fuel Up Education",
      companylogo: require("./assets/images/fuelup.jpg"),
      date: "Jan 2021 - April 2021",
      desc: " Fuel Up Education is a Startup made to give free education for all. Concept is simple by the people for the people",
      descBullets: [
        "Responsible for making REST APIs for their Education Platform with Node JS",
        "Creating the Server and Routes with Express JS",
        "Handling and Querying Data using Mongoose JS on MongoDB"
      ]
    },
    {
      role: "ML Intern",
      company: "Intelligent Machines Lab,ITU",
      companylogo: require("./assets/images/iml.png"),
      date: "July 2019 – Aug 2019",
      desc: "Intelligent Machines Lab, is an endeavor to establish close working relationship among researchers, engineers and developers",
      descBullets: [
        "Responsible for generating training dataset of landscape features, from high resolution satellite imagery data using Labelbox",
        "The dataset was used for prediction of vector borne disease’s prevalence and quantification of agricultural land",
        "This Internship was supervised by NYU"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Developer Student Clubs Lead",
      subtitle: "Powered by Google Developers",
      image: require("./assets/images/gd_dsc_lockup_vertical_color.png"),
      descBullets: [
        "One of the 43 GDSC Leads from Pakistan",
        "Held a workshop on 'How to Complete the Hacktoberfest Challenge' in collaboration with MUET and UCP",
        "Gave a talk on 'Version Control, Git and GitHub",
        "Organized 12+ workshops on various Google Technologies"
      ],
      footerLink: [
        {
          name: "GDSC Club",
          url: "https://dsc.community.dev/information-technology-university/"
        }
        // {
        //   name: "Award Letter",
        //   url:
        // "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        // },
        // {
        //   name: "Google Code-in Blog",
        //   url:
        //     "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        // }
      ]
    },
    {
      title: "Microsoft Learn Student Ambassador",
      subtitle: "Microsoft",
      image: require("./assets/images/MSLearn_SA_badge_generic_rgb_300ppi.png"),
      descBullets: [
        "First Student from ITU, who got selected as a MLSA",
        "Held 5 workshops revolving around 'Git, GitHub, Version Control and Hacktoberfest'",
        "One of Founding Community Builders of Microsoft Learn Student Community Lahore"
      ],

      footerLink: [
        {
          name: "Certificate",
          url: "https://drive.google.com/file/d/1JVAZNI5pdoTZse_1X0MPutfDT7TiLsrd/view?usp=sharing"
        },
        {
          name: "MLSA Profile",
          url: " https://studentambassadors.microsoft.com/en-US/profile/5170"
        }
      ]
    },

    {
      title: "Microsoft Technology Associate",
      subtitle: "Microsoft",
      image: require("./assets/images/MTA-Introduction_to_Programming_Using_JavaScript.png"),
      descBullets: [
        "Completed MTA's Introduction to Programming using JavaScript Certification"
      ],
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1dVyknRMJ5DKqTwRoU3motafsqEJGQLq9/view?usp=sharing"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url: "ttp://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji("⚡ I LOVE COMMUNITY BUILDING ⚡"),

  talks: [
    {
      title: "Let's commit together ft. DSC-ITU",
      subtitle: "HACKTOBERFEST 2020",
      slides_url: "https://github.com/abdullah-ch/Git-Cheat-Sheet",
      event_url:
        "https://www.youtube.com/watch?v=A97tmNdJfII&ab_channel=DeveloperStudentsClub-ITU"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-3124108473",
  email_address: "abdullahchaudharry@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
